<opr-alert></opr-alert>
<opr-loading-bar class="pace">
  <div class="progress-pace"></div>
</opr-loading-bar>
<opr-loading-overlay class="main-overlay" [visible]="showOverlay" [spinnerSize]="80"></opr-loading-overlay>
<opr-splashscreen></opr-splashscreen>
<router-outlet (window:resize)="onResize($event)">
</router-outlet>
